// Símbolo de moneda configurable por empresa (empresas.simbolo_moneda).
// El default coincide con el de la migración 011 y con el fallback del
// backend, para que las tres capas muestren lo mismo si algo falla.
export const SIMBOLO_MONEDA_DEFAULT = "₡"; // ₡ COLON SIGN (U+20A1)

// Mismo formato numérico que el fmtMoney anterior de KpisPage ("es", sin
// decimales); lo único que cambia es que el símbolo deja de ser fijo.
export function fmtMoneda(valor, simbolo) {
  if (valor == null) return "—";
  const s = simbolo || SIMBOLO_MONEDA_DEFAULT;
  return s + Number(valor).toLocaleString("es", { maximumFractionDigits: 0 });
}
